import { locales } from './defaults';

export type Locale = 'en' | 'fr' | 'EN' | 'FR';

export function isLocale(tested: string): tested is Locale {
    return locales.some(locale => locale === tested);
}

// all DR traslations are below type
export type Traslations = {
    [key in Locale]: {
        [key: string]: string;
    };
};
